import { Box3D } from './types'

interface ExportData {
  version: number
  frames: { [frameId: number]: Box3D[] }
}

export function exportJSON(boxes: Box3D[]): void {
  // Group boxes by frameId
  const frames: { [frameId: number]: Box3D[] } = {}
  
  boxes.forEach(box => {
    if (!frames[box.frameId]) {
      frames[box.frameId] = []
    }
    frames[box.frameId].push(box)
  })
  
  const exportData: ExportData = {
    version: 1,
    frames
  }
  
  // Create and download the file
  const dataStr = JSON.stringify(exportData, null, 2)
  const dataBlob = new Blob([dataStr], { type: 'application/json' })
  
  const link = document.createElement('a')
  link.href = URL.createObjectURL(dataBlob)
  link.download = `labels_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.json`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}

export function importJSON(file: File): Promise<Box3D[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    
    reader.onload = (e) => {
      try {
        const content = e.target?.result as string
        const data: ExportData = JSON.parse(content)
        
        // Validate version
        if (data.version !== 1) {
          throw new Error(`Unsupported version: ${data.version}`)
        }
        
        // Flatten frames back to array
        const boxes: Box3D[] = []
        Object.entries(data.frames).forEach(([frameId, frameBoxes]) => {
          frameBoxes.forEach(box => {
            // Ensure frameId is a number
            box.frameId = parseInt(frameId)
            boxes.push(box)
          })
        })
        
        resolve(boxes)
      } catch (error) {
        reject(new Error(`Failed to parse JSON file: ${error}`))
      }
    }
    
    reader.onerror = () => {
      reject(new Error('Failed to read file'))
    }
    
    reader.readAsText(file)
  })
}
